import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { unfixedFloor } from '../../../../utils';

class OverallProgress extends Component {
  render() {
    const overallProgressData = {
      datasets: [
        {
          data: [this.props.totalProgressPercentage, 100 - this.props.totalProgressPercentage],
          backgroundColor: ['#00FA96', '#969696'],
          borderWidth: 0
        }
      ]
    };

    const overallProgressOptions = {
      cutoutPercentage: 80,
      responsive: true,
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      }
    };

    // const totalProgressPercentage = () => this.props.totalProgressPercentage;
    const totalPoints = () => this.props.totalCpdPoints;
    const completedHours = () => this.props.completed;

    const fillText = (ctx, text, fontSize, fontWidth, width, height, textY) => {
      ctx.font = `${fontSize} ${fontWidth}px Open Sans`;
      ctx.textBaseline = 'middle';
      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      ctx.fillStyle = '#ffffff';
      ctx.fillText(text, textX, textY);
    }

    const overallProgressText = {
      beforeDraw: function (chart) {
        var width = chart.chart.width,
          height = chart.chart.height,
          ctx = chart.chart.ctx;
        var fontWidth = width / 7;
        var fontWidthSm = width / 12;
        ctx.restore();

        // fillText(ctx, `${totalProgressPercentage()}%`, 700, fontWidth, width, height, (height / 2) - (fontWidth / 2) + (fontWidth / 5));
        // fillText(ctx, `${unfixedFloor(completedHours(), 2)}/${totalPoints()}`, 600, fontWidthSm, width, height, (height / 2) + (fontWidthSm / 2) + (fontWidth / 5));
        // fillText(ctx, 'CPD Hours', 600, fontWidthSm, width, height, (height / 2) + (fontWidthSm * 1.5) + (fontWidth / 5));

        fillText(ctx, `${unfixedFloor(completedHours(), 2)}/${totalPoints()}h`, 600, fontWidth, width, height, (height / 2) + (fontWidthSm / 2) + (fontWidth / 5));
        ctx.save();
      }
    };

    return <div id='overall-progress'>
      <Doughnut
        data={overallProgressData}
        options={overallProgressOptions}
        plugins={[overallProgressText]}
        width={85}
        height={85} />
    </div>
  }
}

export default OverallProgress;



// WEBPACK FOOTER //
// ./src/containers/pages/app/dashboard/overall-progress.js